import { LightbulbGroupIcon } from './LightbulbGroupIcon';

/**
 * author: Michael Richins
 * id DB267C0E-F298-4380-99C8-E18FA8E06554
 * name lightbulb-group
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-group.svg
 * tags
 * - Home Automation 
 */
export const BulbGroupIcon = LightbulbGroupIcon;
export default BulbGroupIcon